<template>
  <v-app id="wrapper" :class="isLogged && !maintenance ? 'logedin' : ''">
    <NavigationDrawer v-if="isLogged && !maintenance" />
    <!-- <HeaderRegister v-if="userTypeHeader1 !== ''" /> -->
    <v-main
      id="main"
      class="primary-gradient overflow-hidden"
      :style="{
        'padding-bottom':
          $vuetify.breakpoint.mobile &&
          ['Signup'].includes[$router.history.current.name]
            ? '3.5rem'
            : '0',
        ...(['Signup', 'Maintenance'].includes($router.history.current.name)
          ? {
              backgroundImage: `url(${require('./assets/img/bg-drawer.jpg')})`,
              backgroundSize: 'cover',
            }
          : {}),
      }"
    >
      <!-- <AppBar v-if="isLogged" /> -->
      <!-- 'mt-16': isLogged && $vuetify.breakpoint.lgAndUp, -->
      <div class="container">
        <div
          :class="{
            'fill-height': !isLogged || maintenance,
          }"
        >
          <div class="content">
            <router-view />
          </div>
          <!--          <v-row justify="center">
            <v-col :md="isLogged ? 10 : 12" :lg="isLogged ? 8 : 12">

            </v-col>
          </v-row>-->

          <MessageDialog />
          <chat-notification />
          <Toast />
          <ForceUpdateDialog v-if="!maintenance" />
        </div>
      </div>
    </v-main>
    <NavbarBottom v-if="isLogged && !maintenance && $vuetify.breakpoint.mobile" />
    <tour
      v-if="!maintenance"
      name="tourDriverX"
      :steps="tourSteps"
      @next="currentTourStep = $event"
      :disabled="tourDisabled"
      @finish="handleTrouFinished"
    />
  </v-app>
</template>

<script>
import PubNubVue from 'pubnub-vue'
import store from './store'
import { mapGetters, mapActions } from 'vuex'
import NavigationDrawer from '@/components/navigation/NavigationDrawer'
import NavbarBottom from '@/components/navigation/NavbarBottom.vue'
import ChatNotification from './components/chat/ChatNotification.vue'
import soundFile from './assets/sounds/swiftly-610.ogg'
import { iPhoneVersion, isIphone } from '@/utils'
import Tour from '@/components/common/Tour'
import Toast from './components/Toast'
import ForceUpdateDialog from '@/components/common/ForceUpdateDialog'
import { isSiteUnderMaintenance } from '@/utils/maintenance'

const getTourSteps = (userType, isMobile) => {
  return (
    userType === 'student'
      ? [
        {
          target: "[data-v-tour='Home']",
          content: 'View instructors<br>and book lessons'
        },
        {
          target: "[data-v-tour='Bookings']",
          content: 'View upcoming lessons'
        },
        {
          target: "[data-v-tour='Messages']",
          content: 'Chat with instructors<br>and schools'
        },
        {
          target: "[data-v-tour='Notifications']",
          content: 'View changes in bookings'
        },
        ...(isMobile
          ? [
            {
              target: "[data-v-tour='Drawer']",
              content: 'Click to open<br>the drawer menu'
            }
          ]
          : []),

        {
          target: "[data-v-tour='Courses']",
          content: 'Access the course'
        },
        {
          target: "[data-v-tour='Certificate']",
          content: 'View progress and<br>request certificate'
        },
        {
          target: "[data-v-tour='Payments']",
          content: 'Payment history'
        },
        {
          target: "[data-v-tour='Settings']",
          content: 'Configure settings here'
        },
        {
          target: "[data-v-tour='Reviews']",
          content: 'View instructor ratings'
        }
      ]
      : [
        ...(isMobile
          ? [
            {
              target: "[data-v-tour='Drawer']",
              content: 'Click to open<br>the drawer menu'
            }
          ]
          : []),
        {
          target: "[data-v-tour='Packages']",
          content:
              'Set your driving<br>rates and add your<br>banking info to<br>receive payments'
        },
        {
          target: "[data-v-tour='Payments']",
          content: 'View payments received'
        },
        {
          target: "[data-v-tour='Settings']",
          content: 'Configure settings here'
        },
        {
          target: "[data-v-tour='Reviews']",
          content: 'View client reviews'
        },
        {
          target: "[data-v-tour='Bookings']",
          content: 'Manage bookings here'
        },
        {
          target: "[data-v-tour='Messages']",
          content: 'Chat with clients'
        },
        {
          target: "[data-v-tour='Notifications']",
          content: 'Requests and changes<br>for bookings'
        }
      ]
  )
    .map((step) => ({
      ...step,
      params: {
        highlight: true,
        ...(!isMobile && {
          placement: 'right'
        })
      }
    }))
    .filter((item) => item)
}

export default {
  data () {
    return {
      currentTourStep: null,
      tourDisabled: false,
      tourNextDisabled: false,
      nextTourDelay: 0,
      userType: '',
      tourSteps: [],
      maintenance: isSiteUnderMaintenance
    }
  },
  watch: {
    currentTourStep (step) {
      console.log(this.userType, step)
      if (this.userType === 'student' && step === 3) {
        this.$vuetify.breakpoint.mobile && (this.tourDisabled = true)
      }
      if (this.userType === 'instructor' && step === 4) {
        this.$vuetify.breakpoint.mobile && this.toggleDrawer(false)
      }
    },
    drawer (val) {
      if (val) {
        this.tourDisabled = false
      }
    },
    isLogged (val) {
      if (val && !this.maintenance) {
        this.userType = localStorage.getItem('userType')
        if (!this.tourFinished) {
          this.userType === 'instructor' &&
            this.$vuetify.breakpoint.mobile &&
            (this.tourDisabled = true)
          this.tourSteps = getTourSteps(
            this.userType,
            this.$vuetify.breakpoint.mobile
          )
          setTimeout(() => {
            this.$tours.tourDriverX.start()
          }, 1000)
        }
      }
    }
  },
  components: {
    Toast,
    NavigationDrawer,
    NavbarBottom,
    ChatNotification,
    Tour,
    ForceUpdateDialog
  },
  computed: mapGetters([
    'isLogged',
    'globalChannel',
    'user',
    'subscriptions',
    'tourFinished',
    'drawer',
    'userTypeHeader1'
  ]),
  methods: {
    ...mapActions([
      'getSubscriptions',
      'getNotificationSnapbar',
      'getNotificationSnapbar',
      'updateUser',
      'toggleDrawer',
      'toggleTour'
    ]),
    handleTrouFinished () {
      this.$tours.tourDriverX.stop()
      this.$vuetify.breakpoint.mobile && this.toggleDrawer(false)
      this.toggleTour(true)
    },
    initPushNotificationId () {
      window.plugins.OneSignal.getIds((ids) => {
        if (store.getters.isLogged) {
          if (
            typeof ids.userId !== 'undefined' &&
            this.user.get('deviceId') !== ids.userId
          ) {
            this.updateUser({
              deviceId: ids.userId
            })
          }
        }
      })
    }
  },
  async created () {
    if (isIphone()) {
      document.documentElement.classList.add(iPhoneVersion())
    }
    const pubnub = PubNubVue.getInstance()
    /** Get the subscrition, so we don't have to subscribe anywhere else */
    if (store.getters.isLogged && !this.maintenance) {
      this.getSubscriptions({
        id: this.user.id
      })
      if (this.subscriptions) {
        /** Subscribe the current logged in user as online */
        pubnub.subscribe({
          channels: this.subscriptions,
          withPresence: true
        })
      }
    }
  },
  async mounted () {
    document.addEventListener(
      typeof cordova !== 'undefined' ? 'deviceready' : 'DOMContentLoaded',
      () => {
        /** OneSignal Push notification initials */
        if (typeof window.cordova !== 'undefined') {
          if (
            typeof window.plugins !== 'undefined' &&
            typeof window.plugins.OneSignal !== 'undefined'
          ) {
            // Set your iOS Settings
            var iosSettings = {}
            iosSettings.kOSSettingsKeyAutoPrompt = true
            iosSettings.kOSSettingsKeyInAppLaunchURL = true
            window.plugins.OneSignal.startInit(
              'c516ce91-22fd-4478-ab5d-a0f8064ba80b'
            )
              .handleNotificationOpened((jsonData) => {
                console.log(jsonData)
                const payload = jsonData.notification.payload.additionalData
                if (typeof payload !== 'undefined' && payload.type === 'msg') {
                  this.$router.push('./chat/' + payload.id)
                } else if (
                  typeof payload !== 'undefined' &&
                  payload.type === 'appmnt'
                ) {
                  this.$router.push('./dashboard/')
                } else {
                  location.reload()
                }
                // alert("Notification opened: \n" + JSON.stringify(payload));
                // console.log('didOpenRemoteNotificationCallBack: ' + JSON.stringify(jsonData));
              })
              .iOSSettings(iosSettings)
              .inFocusDisplaying(
                window.plugins.OneSignal.OSInFocusDisplayOption.Notification
              )
              .endInit()
            this.initPushNotificationId()
          }

          /** App rate initialize */
          window.AppRate.setPreferences({
            displayAppName: 'DriverX',
            usesUntilPrompt: 3,
            promptAgainForEachNewVersion: false,
            reviewType: {
              ios: 'AppStoreReview',
              android: 'InAppBrowser'
            },
            storeAppURL: {
              ios: '1548524332',
              android: 'market://details?id=com.thedriverx'
            },
            customLocale: {
              title: 'Would you mind rating DriverX?',
              message: 'It won\'t take more than a minute and helps to promote our app. Thanks for your support!',
              cancelButtonLabel: 'No, Thanks',
              laterButtonLabel: 'Remind Me Later',
              rateButtonLabel: 'Rate It Now',
              yesButtonLabel: 'Yes!',
              noButtonLabel: 'Not really',
              appRatePromptTitle: 'Do you like using DriverX?'
              // feedbackPromptTitle: "Mind giving us some feedback?",
            },
            callbacks: {
              // handleNegativeFeedback: function() {
              //   window.open("mailto:feedback@example.com", "_system");
              // },
              onRateDialogShow: (callback) => {
                // eslint-disable-next-line standard/no-callback-literal
                callback(1) // cause immediate click on 'Rate Now' button
              },
              onButtonClicked: (buttonIndex) => {
                console.log('onButtonClicked -> ' + buttonIndex)
              }
            },
            openUrl: (url) => {
              alert('sdsd')
              var safariAvailable = false

              if (window.SafariViewController) {
                Window.SafariViewController.isAvailable((available) => {
                  safariAvailable = available
                })
              }

              if (!safariAvailable) {
                window.open(url, '_blank', 'location=yes')
              } else {
                Window.SafariViewController.show(
                  {
                    url: url,
                    barColor: '#0000ff', // on iOS 10+ you can change the background color as well
                    controlTintColor: '#00ffff', // on iOS 10+ you can override the default tintColor
                    tintColor: '#00ffff' // should be set to same value as controlTintColor and will be a fallback on older ios
                  },

                  // this success handler will be invoked for the lifecycle events 'opened', 'loaded' and 'closed'
                  (result) => {
                    console.log(result.event)
                  },

                  (msg) => {
                    console.log('Error: ' + msg)
                  }
                )
              }
            }
          })
          setTimeout(() => {
            window.AppRate.promptForRating(false)
          }, 5000)
        }
      }
    )
    const pubnub = PubNubVue.getInstance()
    if (store.getters.isLogged) {
      pubnub.addListener({
        message: (m) => {
          if (m.message.receiverId === this.user.id) {
            if (m.channel !== this.globalChannel) {
              var soundsFile = {
                soundurl: soundFile
              }
              var audio = new Audio(soundsFile.soundurl)
              audio.play()
              /** show notification */
              const notification = {
                text: m.message.text,
                sender: {
                  id: m.message.senderId,
                  name: m.message.senderName,
                  avatar: m.message.senderProfilePic
                }
              }
              this.getNotificationSnapbar({ notification, state: true })
            }
          }
        }
      })
    }
  },
  metaInfo: {
    script: [
      {
        innerHTML: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1395749554370487');
          fbq('track', 'PageView');
        `,
        type: 'text/javascript'
      },
      {
        innerHTML: `
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "rgopof12s0");
        `,
        type: 'text/javascript'
      }
    ],
    noscript: [
      {
        innerHTML: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1395749554370487&ev=PageView&noscript=1"/>'
      }
    ]
  }
}
</script>
